import { IconButton } from '../IconButton';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'IconButton',
  category: '🔘 Botões',
  description: 'Botão redondo com ícone — variantes default, primary, danger',
  usedIn: ['ChatHubPage', 'AgentesPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
      <IconButton icon={<span style={{ fontSize: 16 }}>✕</span>} title="Fechar" />
      <IconButton icon={<span style={{ fontSize: 16 }}>🔍</span>} variant="primary" title="Buscar" />
      <IconButton icon={<span style={{ fontSize: 16 }}>🗑️</span>} variant="danger" title="Deletar" />
      <IconButton icon={<span style={{ fontSize: 14 }}>⚡</span>} active title="Ativo" />
      <IconButton icon={<span style={{ fontSize: 14 }}>🚫</span>} disabled title="Desabilitado" />
    </div>
  ),
};
